import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Pencil, Plus, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { kundenAPI, mandantenAPI } from '../lib/api';
import KundeFormModal from '../components/KundeFormModal';

export default function KundenList() {
  const { slug } = useParams();
  const [mandant, setMandant] = useState(null);
  const [kunden, setKunden] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(undefined);

  useEffect(() => {
    mandantenAPI.get(slug).then((r) => setMandant(r.data)).catch(() => {});
  }, [slug]);

  const reload = useCallback(() => {
    setLoading(true);
    return kundenAPI
      .list(slug, { q: q || undefined })
      .then((r) => setKunden(r.data))
      .catch((err) =>
        toast.error(err.response?.data?.detail || 'Kunden konnten nicht geladen werden')
      )
      .finally(() => setLoading(false));
  }, [slug, q]);

  useEffect(() => {
    const t = setTimeout(reload, 200);
    return () => clearTimeout(t);
  }, [reload]);

  const onDelete = async (k) => {
    if (!window.confirm(`Kunde "${k.name}" wirklich löschen?`)) return;
    try {
      await kundenAPI.remove(slug, k.id);
      toast.success('Gelöscht');
      reload();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Löschen fehlgeschlagen');
    }
  };

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Kunden-Stammdaten</h1>
          {mandant && (
            <div className="muted">{mandant.name} · {mandant.skr_variant}</div>
          )}
        </div>
        <div className="header-meta">
          <button className="btn-primary" onClick={() => setEditing(null)}>
            <Plus size={14} /> Neuer Kunde
          </button>
        </div>
      </header>

      <div className="filters">
        <label>
          Suche:
          <input
            type="search" value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Name oder USt-IdNr"
          />
        </label>
      </div>

      {loading ? (
        <div className="muted">Lädt…</div>
      ) : kunden.length === 0 ? (
        <div className="card empty">
          {q ? 'Kein Treffer.' : 'Noch keine Kunden — manuell anlegen oder Ausgangsrechnung erfassen.'}
        </div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>USt-IdNr</th>
              <th>Erlös-Konto</th>
              <th>Debitor-Konto</th>
              <th>USt-Satz</th>
              <th>EU</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {kunden.map((k) => (
              <tr key={k.id}>
                <td><b>{k.name}</b></td>
                <td>{k.ust_id || '—'}</td>
                <td>{k.default_konto || <span className="muted">— Fallback</span>}</td>
                <td>{k.debitor_konto || <span className="muted">— Sammelkonto</span>}</td>
                <td>{k.default_ust_satz != null ? `${Number(k.default_ust_satz)}%` : '—'}</td>
                <td>{k.is_eu_business ? '✓' : ''}</td>
                <td className="row-actions">
                  <button className="btn-text" onClick={() => setEditing(k)} title="Bearbeiten">
                    <Pencil size={14} />
                  </button>
                  <button className="btn-text" onClick={() => onDelete(k)} title="Löschen">
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <KundeFormModal
        open={editing !== undefined}
        onClose={() => setEditing(undefined)}
        slug={slug}
        kunde={editing || undefined}
        onSaved={reload}
      />
    </div>
  );
}
